export default (phoneNumber: string) => { 
    return `+1${phoneNumber.replace(/\D+/g, '')}`
}
